<div class="flex flex-col flex-1 w-full h-full">
  <app-auto-complete
    [searchList]="searchResults"
    [searchBarControl]="searchFormControl"
    [isSearching]="isSearching"
    [placeholder]="placeholder"
    (handleSelectedResult)="onAdd($event)"
    class="flex flex-col flex-1"
  ></app-auto-complete>
  <div
    class="flex items-center pb-4 text-xs gap-x-2 text-project-2100"
    *ngIf="isLoadingManagerDetails"
  >
    <mat-spinner [diameter]="12"></mat-spinner>
    <span>Loading Manager details</span>
  </div>
  <div class="py-1" *ngFor="let item of selectedManagers.controls">
    <app-related-manager-item
      [managerControl]="item"
      [availableSectors]="item.value.sectors"
      [isSurtitleButtonShown]="isSurtitleButtonShown"
      [isSmartLinked]="isManagerSmartLinked(item)"
      (handleRemove)="onRemove($event)"
      (handleAdd)="onAdd($event)"
      (handleInfoClick)="onInfoClick($event)"
      (handleAddToBody)="onAddToBody($event)"
      (handleSectorChange)="onSectorChange()"
      (handlePromote)="onPromoteManagerToSurtitle($event)"
    >
    </app-related-manager-item>
  </div>
  <div class="flex flex-1 w-full my-2 text-xs">
    <p data-testid="sector-tagging-info-text">
      <i class="icon icon-info-circle"></i>
      For more info on sector-tagging best practice,
      <a target="_blank" href="{{ this.appConfig.taggingFAQ }}">click here</a>
    </p>
  </div>
</div>
